import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LangCtx, PayLoadCtx, CustomCtx } from "../../lib/context";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Auth } from "@aws-amplify/auth";
import { toast } from "react-toastify";
import "./profileMenu.css";

function ProfileMenu(props) {
    const { isOpen, onClose, handleLogout } = props;

    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const { custom } = useContext(CustomCtx);
    const location = useLocation();
    const navigate = useNavigate();

    const role = payload?.consultRole;

    const handleItemClick = () => {
        onClose();
    };

    const handleLogoutClick = async () => {
        onClose();
        if (handleLogout) {
            await handleLogout();
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <>
            <div className="profile-menu-overlay" onClick={onClose} />

            <div className="profile-menu">
                <div className="profile-menu-header">
                    <h3>{l.my_profile || "Profile"}</h3>
                    <IconButton onClick={onClose} size="small" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className="profile-menu-items">
                    {role === "doctor" && (
                        <Link
                            to="/doctor-profile"
                            className={location.pathname === "/doctor-profile" ? "profile-menu-item active" : "profile-menu-item"}
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/profile-outline.png" alt="Profile" className="menu-item-icon" />
                            <span>{l.my_profile || "My Profile"}</span>
                        </Link>
                    )}

                    {role === "clinic" && (
                        <Link
                            to="/edit-profile"
                            className={location.pathname === "/edit-profile" ? "profile-menu-item active" : "profile-menu-item"}
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/profile-outline.png" alt="Profile" className="menu-item-icon" />
                            <span>{l.my_profile || "My Profile"}</span>
                        </Link>
                    )}

                    {role === "Admin" && (
                        <Link
                            to="/admin-profile"
                            className={location.pathname === "/admin-profile" ? "profile-menu-item active" : "profile-menu-item"}
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/profile-outline.png" alt="Profile" className="menu-item-icon" />
                            <span>{l.my_profile || "My Profile"}</span>
                        </Link>
                    )}

                    {!role || (role !== "doctor" && role !== "clinic" && role !== "Admin") ? (
                        <Link
                            to="/patient-profile"
                            className={location.pathname === "/patient-profile" ? "profile-menu-item active" : "profile-menu-item"}
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/profile-outline.png" alt="Profile" className="menu-item-icon" />
                            <span>{l.my_profile || "My Profile"}</span>
                        </Link>
                    ) : null}

                    {role === "doctor" && (
                        <>
                            <Link
                                to="/doctor-coupon"
                                className={location.pathname === "/doctor-coupon" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/appointments-outline.png" alt="Coupons" className="menu-item-icon" />
                                <span>{l.coupons || "Coupons"}</span>
                            </Link>
                            <Link
                                to="/doctor-settings"
                                className={location.pathname === "/doctor-settings" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/settings-outline.png" alt="Settings" className="menu-item-icon" />
                                <span>{l.settings || "Settings"}</span>
                            </Link>
                        </>
                    )}

                    {role === "clinic" && (
                        <>
                            <Link
                                to="/doctor-report"
                                className={location.pathname === "/doctor-report" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/medical-reports-outline.png" alt="Reports" className="menu-item-icon" />
                                <span>{l.reports || "Reports"}</span>
                            </Link>
                            <Link
                                to="/clinic-createusers"
                                className={location.pathname === "/clinic-createusers" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/create-patient.png" alt="Create Users" className="menu-item-icon" />
                                <span>{l.create_user || "Create Users"}</span>
                            </Link>
                            <Link
                                to="/clinic-uploads"
                                className={location.pathname === "/clinic-uploads" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/uploads-outline.png" alt="Uploads" className="menu-item-icon" />
                                <span>{l.uploads || "Uploads"}</span>
                            </Link>
                            <Link
                                to="/clinic-config"
                                className={location.pathname === "/clinic-config" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/settings-config-outline.png" alt="Configuration" className="menu-item-icon" />
                                <span>{l.configuration || "Configuration"}</span>
                            </Link>
                            <Link
                                to="/clinic-license"
                                className={location.pathname === "/clinic-license" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/license-Management.png" alt="Licenses" className="menu-item-icon" />
                                <span>{l.licenses || "Licenses"}</span>
                            </Link>
                            <Link
                                to="/clinic-settings"
                                className={location.pathname === "/clinic-settings" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/settings-outline.png" alt="Settings" className="menu-item-icon" />
                                <span>{l.settings || "Settings"}</span>
                            </Link>
                        </>
                    )}

                    {role === "Admin" && (
                        <>
                            <Link
                                to="/admin-reports"
                                className={location.pathname === "/admin-reports" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/medical-reports-outline.png" alt="Reports" className="menu-item-icon" />
                                <span>{l.reports || "Reports"}</span>
                            </Link>
                            <Link
                                to="/admin-settings"
                                className={location.pathname === "/admin-settings" ? "profile-menu-item active" : "profile-menu-item"}
                                onClick={handleItemClick}
                            >
                                <img src="/images/icons/settings-outline.png" alt="Settings" className="menu-item-icon" />
                                <span>{l.settings || "Settings"}</span>
                            </Link>
                        </>
                    )}

                    {(role === "Patient" || !role || (role !== "doctor" && role !== "clinic" && role !== "Admin")) && (
                        <Link
                            to="/patient-settings"
                            className={location.pathname === "/patient-settings" ? "profile-menu-item active" : "profile-menu-item"}
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/settings-outline.png" alt="Settings" className="menu-item-icon" />
                            <span>{l.settings || "Settings"}</span>
                        </Link>
                    )}

                    {custom?.subDomain === process.env.REACT_APP_subdomain && (
                        <a
                            href="https://help.instavc.com/inclinic"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="profile-menu-item"
                            onClick={handleItemClick}
                        >
                            <img src="/images/icons/play-button.png" alt="Help Center" className="menu-item-icon" />
                            <span>{l.help_center || "Help Center"}</span>
                        </a>
                    )}

                    <div className="profile-menu-divider" />

                    <div className="profile-menu-item" onClick={handleLogoutClick}>
                        <img src="/images/icons/logout-outline.png" alt="Logout" className="menu-item-icon" />
                        <span>{l.logout || "Logout"}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfileMenu;
